export const EDITOR_MODE_DEFAULT = 'editor';
export const EDITOR_MODE_GLOBAL_TEMPLATE_MANAGER = 'global-template-manager';
export const EDITOR_MODE_ORG_TEMPLATE_MANAGER = 'org-template-manager';

export const QR_TYPE_WEBSITE = 'Sito Web';
export const QR_TYPE_WHATSAPP = 'Whatsapp';
export const QR_TYPE_PHONE = 'Telefono';
